<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">
        {{'pages.footer-entity.footer-entity-items-create.title' | translate}}  
    </div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">

        <!--main input-->
        <div class="row px-3">
            <div class="col-12">
                <div class="m-3">
                    <label for="field_listTitle" class="form-label label-fw">
                        {{'pages.footer-entity.footer-entity-items-create.form.label-fields.listTitle' | translate}}
                        *
                    </label>
                    <input formControlName="listTitle" name="listTitle" 
                    [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.listTitle.errors}"
                    type="text" class="form-control form-fw " id="field_listTitle" placeholder="Titolo sezione lista">
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.listTitle.errors && formControls.listTitle.errors?.required">
                            {{'pages.footer-entity.footer-entity-items-create.form.errors.listTitle-required' | translate}}
                        </span>
                    </div>
                </div>
            </div> 
            <div class="col-12">
                <div class="m-3">
                    <label for="field_title" class="form-label label-fw">
                        {{'pages.footer-entity.footer-entity-items-create.form.label-fields.title' | translate}}
                         *
                    </label>
                    <input  formControlName="title" 
                            name="title" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.title.errors}"
                            type="text" 
                            class="form-control form-fw " id="field_title" placeholder="Titolo sezione">
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.title.errors && formControls.title.errors?.required">
                            {{'pages.footer-entity.footer-entity-items-create.form.errors.title-required' | translate}}
                        </span>
                    </div>
                </div>
            </div>  
            <div class="col-6">
                <div class="m-3">
                    <label for="field_index" class="form-label label-fw">
                        {{'pages.footer-entity.footer-entity-items-create.form.label-fields.index' | translate}}
                        *
                    </label>
                    <input formControlName="index" name="index" type="number" class="form-control form-fw " id="field_index" placeholder="Posizione" disabled>
                </div>
            </div> 
            <div class="col-6">
                <div class="m-3">
                    <label for="field_boxSize" class="form-label label-fw">
                        {{'pages.footer-entity.footer-entity-items-create.form.label-fields.boxSize' | translate}}
                        *
                    </label>
                    <input formControlName="boxSize" name="boxSize" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.boxSize.errors}"
                            type="number" min="1" max="12" class="form-control form-fw " id="field_boxSize" placeholder="Dimensione box">
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.boxSize.errors && formControls.boxSize.errors?.required">
                            {{'pages.footer-entity.footer-entity-items-create.form.errors.boxSize-required' | translate}}
                        </span>
                        <span *ngIf="formControls.boxSize.errors && formControls.boxSize.errors?.max">
                            {{'pages.footer-entity.footer-entity-items-create.form.errors.boxSize-max' | translate}}
                        </span>
                        <span *ngIf="formControls.boxSize.errors && formControls.boxSize.errors?.min">
                            {{'pages.footer-entity.footer-entity-items-create.form.errors.boxSize-min' | translate}}
                        </span>
                    </div>
                </div>
            </div> 
            <div class="col-12">
                <div class="m-3">
                    <label for="field_externalLink" class="form-label label-fw">
                        {{'pages.footer-entity.footer-entity-items-create.form.label-fields.externalLink' | translate}}
                    </label>
                    <input formControlName="externalLink" name="externalLink" type="text"
                        class="form-control form-fw " id="field_externalLink" placeholder="Link">
                </div>
            </div>            
        </div>
        <div class="row px-3">
            <div class="col-12">
                <div class="m-3">
                    <label for="field_content" class="form-label label-fw">
                        {{'pages.footer-entity.footer-entity-items-create.form.label-fields.content' | translate}}
                    </label>
                    <ckeditor [(ngModel)]="ckValue" [ngModelOptions]="{standalone: true}" #ckeditor="ngModel"
                        name="ckeditor" required [config]="ckeConfig" (ngModelChange)="change()" debounce="500">
                    </ckeditor>
                </div>
            </div>
        </div>
    </form>

    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3" 
            [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false " 
            (click)="clickButtonSave()">
                {{'pages.footer-entity.footer-entity-items-create.buttons.save' | translate}}
            </button>
            <button type="button" class="btn btn-outline-fw text" (click)="clickButtonCancel()">
                {{'pages.footer-entity.footer-entity-items-create.buttons.cancel' | translate}}
            </button>
        </div>
    </div>

</div>